export const RATE_LIMITED = 'EmailSendingApiError.RATE_LIMITED';